import { MessageCircle } from "lucide-react";
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-14 h-14 rounded-lg flex items-center justify-center">
                <img src="https://ik.imagekit.io/anvgrd1ahnys/DALM/Dalm%20Logos%20IMGKIT/favicon-dalm-test/apple-touch-icon_Hg0-6reJdv.png?updatedAt=1750176559662" alt="logo" />
              </div>
              <span className="text-xl font-bold text-gray-900">ConvoHub</span>
            </div>
            <p className="text-gray-600 mb-4">
              The complete multichannel messaging platform for modern
              businesses.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 mb-4">Company</h3>
            <ul className="space-y-2 text-gray-600">
              <li>
                <a
                  href="https://dalmlabs.com/about"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-900"
                >
                  About
                </a>
              </li>

              <li>
                <a
                  href="https://dalmlabs.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-900"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 mb-4">Support</h3>
            <ul className="space-y-2 text-gray-600">
              <li>
                <a
                  href="https://dalmlabs.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-900"
                >
                  Help Center
                </a>
              </li>

              <li>
                <a
                  href="https://dalmlabs.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-900"
                >
                  Privacy
                </a>
              </li>
             
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 text-center text-gray-500">
          <p>© 2024 ConvoHub All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
